module.exports = __webpack_public_path__ + "static/media/view.861f2f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/view.png
// module id = 1578
// module chunks = 0